/** Grouped number for the language the screen is showing (`en-US` for English). */
export function formatNumber(value: number, locale: string): string {
  return value.toLocaleString(locale);
}

/** Date and time for the language the screen is showing. */
export function formatDateTime(value: Date, locale: string): string {
  return value.toLocaleString(locale);
}
